var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStyles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.1,
    cy: 10.7,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3,
    cy: 10.7,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.6,
    cy: 10.7,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2,6H10.3C8.2,6,6.6,7.7,6.6,9.7v11.7c0,0.6,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2V15h39.7v22.2 c0,0.8-0.6,1.4-1.4,1.4H26c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2h21.2c2.1,0,3.7-1.7,3.7-3.7V9.7C50.9,7.7,49.2,6,47.2,6z  M8.9,12.7v-3c0-0.8,0.6-1.4,1.4-1.4h36.9c0.8,0,1.4,0.6,1.4,1.4v3H8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6,37.9c1.5,0,2.7-1.2,2.7-2.7v-5.6h3.4c1.1,0,2-0.9,2-2v-8.2c0-1.1-0.9-2-2-2H27.3c-0.6,0-1.2,0.5-1.2,1.2 c0,0.6,0.5,1.2,1.2,1.2h16.2v7.7h-4.3c-0.6,0-1.2,0.5-1.2,1.2v6.8c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-2.9 c0-1.5-1.2-2.7-2.7-2.7s-2.7,1.2-2.7,2.7v1.8c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-0.7c0-0.6-0.5-1.2-1.2-1.2 c-0.6,0-1.2,0.5-1.2,1.2v0.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7v-1.8c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v2.9 C34.9,36.7,36.1,37.9,37.6,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,29.5c0.9-0.9,0.9-2.3,0-3.1l-9.1-9.1c-0.9-0.9-2.3-0.9-3.1,0l-6.3,6.3c-0.7-0.1-1.4,0.1-1.9,0.6 l-2.7,2.7c-0.9,0.9-0.9,2.3,0,3.1l3.3,3.3c-0.5,0.6-1.3,1.3-1.8,1.7c-0.3,0.2-0.8,0.5-1.3,0.8c-1,0.6-2.3,1.3-3.4,2.4 c-1,1-1.7,2-2.1,2.9C0.8,42.6,1,44,2,45c0.7,0.7,1.5,1,2.2,1c1.8,0,3.7-1.6,4.6-2.5c1-1,1.8-2.3,2.4-3.4c0.3-0.5,0.6-1,0.8-1.3 c0.4-0.5,1.1-1.2,1.7-1.8l3.3,3.3c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.6-0.6l2.7-2.7c0.5-0.5,0.7-1.2,0.6-1.9L29.7,29.5z  M10.2,37.4c-0.3,0.4-0.7,1-1,1.6c-0.5,1-1.2,2-2,2.9c-0.7,0.7-2.6,2.4-3.5,1.5c-0.2-0.2-0.5-0.5-0.1-1.3c0.3-0.6,0.8-1.4,1.6-2.2 c0.8-0.8,1.9-1.4,2.9-2c0.6-0.4,1.2-0.7,1.6-1c0.6-0.5,1.3-1.2,1.9-1.8l0.4,0.4C11.4,36.1,10.6,36.8,10.2,37.4z M19.1,19.1L28,28 l-5.9,5.9l-1.6-1.6l2.7-2.7c0.5-0.5,0.5-1.2,0-1.7c-0.5-0.5-1.2-0.5-1.7,0l-2.7,2.7L18,29.7l2-2c0.5-0.5,0.5-1.2,0-1.7 c-0.5-0.5-1.2-0.5-1.7,0l-2,2l-0.8-0.8l1.4-1.4c0.5-0.5,0.5-1.2,0-1.7c-0.5-0.5-1.2-0.5-1.7,0l-1.4,1.4L13.2,25L19.1,19.1z  M18.6,38.6L8.4,28.5L11,26l2.1,2.1c0,0,0,0,0,0c0,0,0,0,0,0l8,8L18.6,38.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStyles);
export default __webpack_public_path__ + "static/media/icon-styles.d6b01272654fc5e0bb38679daa882a8a.svg";
export { ForwardRef as ReactComponent };